<div>
  <div bsModal #sendEmailModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content email-modal">
        <!-- Header -->
        <div class="email-modal__header">
          <div class="email-modal__title">Email preview</div>
          <!-- <button type="button" class="email-modal__close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
          </button> -->
          <div class="close-button cross" (click)="cancel()">
            <img _ngcontent-fup-c356="" style="height: 24px; width: 24px" src="assets/img/x.svg" alt="" />
          </div>
        </div>

        <!-- Divider under header -->
        <div class="email-modal__divider"></div>

        <div class="modal-body email-modal__body">
          <!-- From / Reply-To row -->
          <div class="email-modal__top-meta">
            <div class="meta-item">
              <div class="meta-label">From:</div>
              <div class="meta-value">
                {{ productType?.emailSender ? productType?.emailSender : 'support@agrisku.com' }}
              </div>
            </div>
            <div class="meta-item">
              <div class="meta-label">Reply-To:</div>
              <div class="meta-value">
                {{ productType?.emailReplyTo ? productType?.emailReplyTo : 'poultry@agrisku.com' }}
              </div>
            </div>
          </div>

          <div class="email-modal__separator"></div>

          <!-- Form Fields -->
          <form class="email-form" [formGroup]="form">
            <!-- To -->
            <div class="email-field">
              <div class="field-label">To:</div>
              <div class="field-control">
                <input id="emailTo" formControlName="to" class="field-input" />
                <i
                  class="fa fa-times field-clear"
                  aria-hidden="true"
                  (click)="resetControlToDefault('to')"
                  *ngIf="this.fieldChanges.to"></i>
              </div>
              <div
                class="field-error"
                *ngIf="form.get('to').errors?.required || form.get('to').errors?.invalidEmails?.invalidEmails == ''">
                Please enter valid email addresses, separated by commas.
              </div>
              <div
                class="field-error"
                *ngIf="
                  form.get('to').errors?.invalidEmails &&
                  form.get('to').errors?.invalidEmails?.invalidEmails &&
                  form.get('to').errors?.invalidEmails?.invalidEmails != ''
                ">
                {{ form.get('to').errors?.invalidEmails?.invalidEmails }} is not a valid email
              </div>
              <div class="field-error" *ngIf="form.get('to').errors?.duplicateEmails">
                Duplicate emails are not allowed.
              </div>
            </div>

            <!-- Cc -->
            <div class="email-field">
              <div class="field-label">Cc:</div>
              <div class="field-control">
                <input id="emailCc" formControlName="cc" class="field-input" />
                <i
                  class="fa fa-times field-clear"
                  aria-hidden="true"
                  (click)="resetControlToDefault('cc')"
                  *ngIf="this.fieldChanges.cc"></i>
              </div>
              <div
                class="field-error"
                *ngIf="
                  form.get('cc').errors?.invalidEmails &&
                  form.get('cc').errors?.invalidEmails?.invalidEmails &&
                  form.get('cc').errors?.invalidEmails?.invalidEmails != ''
                ">
                {{ form.get('cc').errors?.invalidEmails?.invalidEmails }} is not a valid email
              </div>
              <div class="field-error" *ngIf="form.get('cc').errors?.invalidEmails?.invalidEmails == ''">
                Please enter valid email addresses, separated by commas.
              </div>
              <div class="field-error" *ngIf="form.get('cc').errors?.duplicateEmails">
                Duplicate emails are not allowed.
              </div>
              <div class="field-error" *ngIf="form.errors?.emailsCrossMatch">
                Email addresses in Cc and To fields must be different.
              </div>
            </div>

            <!-- Subject -->
            <div class="email-field">
              <div class="field-label">Subject:</div>
              <div class="field-control">
                <input id="subject" formControlName="subject" class="field-input" />
                <i
                  class="fa fa-times field-clear"
                  aria-hidden="true"
                  (click)="resetControlToDefault('subject')"
                  *ngIf="this.fieldChanges.subject"></i>
              </div>
              <div
                class="field-error"
                *ngIf="
                  form.get('subject').errors?.required || form.get('subject').errors?.invalidEmails?.invalidEmails == ''
                ">
                Subject is required
              </div>
            </div>

            <!-- Email body preview sections -->
            <div class="email-content">
              <div [innerHTML]="emailContents[0]"></div>
              <div [innerHTML]="emailContents[1]"></div>
              <div [innerHTML]="emailContents[2]"></div>

              <!-- Custom editor -->
              <div id="toolbar-container" style="padding: 0px 71px" class="editor-toolbar"></div>
              <div class="editor-wrapper" style="padding: 0px 101px">
                <div style="padding: 24px; background-color: #ffffff">
                  <div class="editor-input-shell">
                    <editor #editor [init]="tinyInit" formControlName="customField"></editor>
                  </div>
                </div>
              </div>

              <div [innerHTML]="emailContents[3]"></div>
            </div>
          </form>
        </div>

        <!-- Footer -->
        <div class="email-modal__footer">
          <button type="button" style="width: 94px; height: 43px" class="btn btn-outline" (click)="cancel()">
            Cancel
          </button>
          <button
            type="button"
            style="width: 118px; height: 39px"
            class="btn btn-primary"
            [disabled]="!form.valid"
            (click)="sendEmail()">
            Send email
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
